import { IconButton } from '@mui/material';
import React, { SetStateAction, useState } from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Backstage from 'interfaces/Backstage.interface';
import { IMessage } from 'interfaces/message.interface';

interface IContentProps {
  image?: string;
  current?: boolean;
  addOrRemovePost: (
    id: number | null,
    setSelected: SetStateAction<any>
  ) => void;
  addOrRemoveMessage: (
    id: string | null,
    setSelected: SetStateAction<any>
  ) => void;
  handlePremium?: (price: string) => void;
  setSelectedCurrentPost: SetStateAction<any>;
  data?: Backstage;
  price: string;
  message?: IMessage;
}

const Content = ({
  image,
  current,
  addOrRemovePost,
  data,
  handlePremium,
  price,
  setSelectedCurrentPost,
  addOrRemoveMessage,
  message,
}: IContentProps) => {
  const [hover, setHover] = useState<boolean>(false);
  const [selected, setSelected] = useState<boolean>(false);
  const handleSelectedPremium = () => {
    if (selected) {
      handlePremium && handlePremium('');
      setSelected(false);
      setSelectedCurrentPost(false);
    } else {
      handlePremium && handlePremium(price);
      setSelected(true);
      setSelectedCurrentPost(true);
    }
  };
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() =>
        current
          ? handleSelectedPremium()
          : message
          ? addOrRemoveMessage(message ? message.id : null, setSelected)
          : addOrRemovePost(data ? data.id : null, setSelected)
      }
      className="post-container"
    >
      <div
        style={{
          opacity: hover || selected ? '1' : '0',
          transition: 'all 250ms easeInOut',
        }}
        className="overlay"
      >
        <IconButton className="lock-btn">
          <LockOutlinedIcon sx={{ color: 'white' }} />
        </IconButton>
      </div>
      {current ? (
        <h3 className="content-current">Current Post</h3>
      ) : (
        <video
          autoPlay
          muted
          className="content-img"
          poster={image}
          src={image}
        ></video>
      )}
    </div>
  );
};

export default Content;
